// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
export var ReviewedStatus;
(function (ReviewedStatus) {
    ReviewedStatus["UNKNOWN_REVIEWED_STATUS"] = "UNKNOWN_REVIEWED_STATUS";
    ReviewedStatus["PENDING"] = "PENDING";
    ReviewedStatus["ACCEPTED"] = "ACCEPTED";
    ReviewedStatus["REJECTED"] = "REJECTED";
})(ReviewedStatus || (ReviewedStatus = {}));
export var ReviewedStatus_index;
(function (ReviewedStatus_index) {
    ReviewedStatus_index[ReviewedStatus_index["UNKNOWN_REVIEWED_STATUS"] = 0] = "UNKNOWN_REVIEWED_STATUS";
    ReviewedStatus_index[ReviewedStatus_index["PENDING"] = 1] = "PENDING";
    ReviewedStatus_index[ReviewedStatus_index["ACCEPTED"] = 2] = "ACCEPTED";
    ReviewedStatus_index[ReviewedStatus_index["REJECTED"] = 3] = "REJECTED";
})(ReviewedStatus_index || (ReviewedStatus_index = {}));
export var OrderBy;
(function (OrderBy) {
    OrderBy["UNKNOWN_ORDER_BY"] = "UNKNOWN_ORDER_BY";
    OrderBy["CREATED_AT"] = "CREATED_AT";
    OrderBy["UPDATED_AT"] = "UPDATED_AT";
    OrderBy["REVIEWED_AT"] = "REVIEWED_AT";
})(OrderBy || (OrderBy = {}));
export var OrderBy_index;
(function (OrderBy_index) {
    OrderBy_index[OrderBy_index["UNKNOWN_ORDER_BY"] = 0] = "UNKNOWN_ORDER_BY";
    OrderBy_index[OrderBy_index["CREATED_AT"] = 1] = "CREATED_AT";
    OrderBy_index[OrderBy_index["UPDATED_AT"] = 2] = "UPDATED_AT";
    OrderBy_index[OrderBy_index["REVIEWED_AT"] = 3] = "REVIEWED_AT";
})(OrderBy_index || (OrderBy_index = {}));
export var BookingSource;
(function (BookingSource) {
    BookingSource["UNKNOWN_BOOKING_SOURCE"] = "UNKNOWN_BOOKING_SOURCE";
    BookingSource["BOOKING_SITE"] = "BOOKING_SITE";
    BookingSource["GOOGLE_BUSINESS_PROFILE"] = "GOOGLE_BUSINESS_PROFILE";
})(BookingSource || (BookingSource = {}));
export var BookingSource_index;
(function (BookingSource_index) {
    BookingSource_index[BookingSource_index["UNKNOWN_BOOKING_SOURCE"] = 0] = "UNKNOWN_BOOKING_SOURCE";
    BookingSource_index[BookingSource_index["BOOKING_SITE"] = 1] = "BOOKING_SITE";
    BookingSource_index[BookingSource_index["GOOGLE_BUSINESS_PROFILE"] = 2] = "GOOGLE_BUSINESS_PROFILE";
})(BookingSource_index || (BookingSource_index = {}));
